// extracted by mini-css-extract-plugin
export var addButton = "_e0-0";
export var border = "_e0-8";
export var check = "_e0-h";
export var danger = "_e0-6";
export var dropdownContainer = "_e0-1";
export var editModalBody = "_e0-j";
export var footerContainer = "_e0-i";
export var fullWidth = "_e0-a";
export var hide = "_e0-9";
export var icon = "_e0-3";
export var input = "_e0-7";
export var inputFlex = "_e0-b";
export var inputWrapper = "_e0-c";
export var manualFocus = "_e0-5";
export var optionButton = "_e0-4";
export var pillWrapper = "_e0-e";
export var pointer = "_e0-2";
export var showOverflow = "_e0-f";
export var tagsFlex = "_e0-d";
export var xButton = "_e0-g";